import { render, staticRenderFns } from "./ExtensionPanel.vue?vue&type=template&id=738c2b23&"
import script from "./ExtensionPanel.vue?vue&type=script&lang=js&"
export * from "./ExtensionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports